import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

/**
 * The error row of a grid: a light red banner with the message and a close
 * button, shown in the place of the column headers. The message may be a
 * translation key; a message without translation is shown as it is.
 */
@Component({
  selector: 'app-grid-error',
  template: `<div class="grid-error" role="alert">
    <span class="grid-error-message">{{
      message ? (message | translate) : ''
    }}</span>
    <button
      type="button"
      class="grid-error-close"
      title="Close"
      (click)="closed.emit()"
    >
      <i class="app-icon fa-solid fa-xmark"></i>
    </button>
  </div>`,
  styleUrls: ['./grid-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridErrorComponent {
  @Input() message: string | null = null;
  @Output() closed = new EventEmitter<void>();
}
